import React, { useState, useEffect } from 'react'

const CountdownTimer = ({ expiryDate, spinTime }) => {
  const [timeLeft, setTimeLeft] = useState([])

  const getDifferenceUntilNextUTCMidnightInMilliseconds = () => {
    // let options = {
    //   timeZone: 'America/New_York',
    //   year: 'numeric',
    //   month: 'numeric',
    //   day: 'numeric',
    //   hour: 'numeric',
    //   minute: 'numeric',
    //   second: 'numeric',
    // }
    // let currentDateInEST = new Intl.DateTimeFormat([], options);
    // let currentDateInESTAsADateObject = new Date(currentDateInEST.format(new Date()))
    // let nextESTMidnightDate = new Date(currentDateInEST.format(new Date()))
    // nextESTMidnightDate.setDate(nextESTMidnightDate.getDate() + 1);
    // nextESTMidnightDate.setHours(0);
    // nextESTMidnightDate.setMinutes(0);
    // nextESTMidnightDate.setSeconds(0);

    // console.log(currentDateInESTAsADateObject)
    // console.log('next EST midnight: ',nextESTMidnightDate)

    let optionsUTC = {
      timeZone: 'UTC',
      year: 'numeric',
      month: 'numeric',
      day: 'numeric',
      hour: 'numeric',
      minute: 'numeric',
      second: 'numeric',
    }

    let currentDateInUTC = new Intl.DateTimeFormat([], optionsUTC)
    let currentDateInUTCAsADateObject = new Date(
      currentDateInUTC.format(new Date()),
    )
    let utcHrsMinsSecondsToSeconds =
      currentDateInUTCAsADateObject.getHours() * 3600 +
      currentDateInUTCAsADateObject.getMinutes() * 60 +
      currentDateInUTCAsADateObject.getSeconds()
    let timeUntilUTCMidnightInSeconds = 24 * 3600 - utcHrsMinsSecondsToSeconds

    // console.log(currentDateInUTCAsADateObject)
    // console.log('difference: ',timeUntilUTCMidnightInSeconds)

    return timeUntilUTCMidnightInSeconds * 1000
  }

  const calculateTimeLeft = expiryDate => {
    let timeLeft = {}

    if (expiryDate) {
      const difference = +new Date(expiryDate) - +new Date()

      if (difference > 0) {
        timeLeft = {
          days: Math.floor(difference / (1000 * 60 * 60 * 24)),
          hours: ('0' + Math.floor((difference / (1000 * 60 * 60)) % 24)).slice(
            -2,
          ),
          minutes: ('0' + Math.floor((difference / 1000 / 60) % 60)).slice(-2),
          seconds: ('0' + Math.floor((difference / 1000) % 60)).slice(-2),
        }
      } else {
        timeLeft = {
          expired: true,
        }
      }
    } else if (spinTime) {
      const difference = getDifferenceUntilNextUTCMidnightInMilliseconds()

      if (difference > 0) {
        timeLeft = {
          hours: Math.floor((difference / (1000 * 60 * 60)) % 24),
          minutes: Math.floor((difference / 1000 / 60) % 60),
        }
      } else {
        timeLeft = {
          freeSpin: true,
        }
      }
    }

    return timeLeft
  }

  useEffect(() => {
    setTimeout(() => {
      setTimeLeft(calculateTimeLeft(expiryDate, spinTime))
    }, 1000)
  })

  return (
    <>
      {expiryDate && (
        <span className={`expiry${timeLeft.days < 3 ? ' hot' : ''}`}>
          {timeLeft.days > 2 && `${timeLeft.days} Days `}
          {timeLeft.days > 0 && timeLeft.days <= 2 && `${timeLeft.days}d `}
          {timeLeft.days <= 2 && timeLeft.hours >= 0 && `${timeLeft.hours}h `}
          {timeLeft.days <= 2 &&
            timeLeft.minutes >= 0 &&
            `${timeLeft.minutes}m `}
          {timeLeft.days <= 2 &&
            timeLeft.seconds >= 0 &&
            `${timeLeft.seconds}s`}

          {timeLeft.expired && 'Expired!'}
        </span>
      )}
      {spinTime && (
        <>
          <span>
            {!timeLeft.freeSpin &&
              timeLeft.hours !== undefined &&
              timeLeft.minutes !== undefined &&
              `${timeLeft.hours}h ${timeLeft.minutes}m`}
            {timeLeft.freeSpin && `NOW!`}
          </span>
          <span>(12:00 am UTC)</span>
        </>
      )}
    </>
  )
}

export default CountdownTimer
